import React from 'react';
import clsx from 'clsx';
import styles from './Patterns.module.scss';

export function LoadingState({ label, className }) {
  return <div role="status" aria-live="polite" className={clsx(styles.state, className)}>
    <span className={styles.progress} aria-hidden="true" />{label}
  </div>;
}
export function EmptyState({ title, description, action, icon, className }) {
  return <div className={clsx(styles.state, className)}>
    {icon && <span aria-hidden="true">{icon}</span>}
    <h3>{title}</h3>{description && <p>{description}</p>}{action}
  </div>;
}
export function Alert({ children, variant = 'error', live = false, className, ...props }) {
  return <div {...props} role={live ? (variant === 'error' ? 'alert' : 'status') : undefined}
    className={clsx(styles.alert, styles[variant], className)}>{children}</div>;
}
